import Axios from '../plugins/axios'

export const createParking = function (parking) {
    return Axios.post('parkings', parking)
}

export const fetchParkings = function () {
    return Axios.get('parkings?lang=bg')
}

export const fetchParking = function (id) {
    return Axios.get(`parkings/${id}?lang=bg`)
}

export const updateParking = function (id, parking) {
    return Axios.put(`parkings/${id}`, parking)
}

export const removeParking = function (id) {
    return Axios.delete('parkings/' + id)
}